// extracted by mini-css-extract-plugin
export default {"root":"TextArea_root__XnYpQ","fullWidth":"TextArea_fullWidth__6k1SL","isIOS":"TextArea_isIOS__hWnh0"};